module.exports = __webpack_public_path__ + "img/IconApi.f378b40d.png";